import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_INVOICES_STATS_REQUEST = "FETCH_INVOICES_STATS_REQUEST";
export const FETCH_INVOICES_STATS_SUCCESS = "FETCH_INVOICES_STATS_SUCCESS";
export const FETCH_INVOICES_STATS_ERROR = "FETCH_INVOICES_STATS_ERROR";
export const CLEAN_INVOICES_STATS_STATE = "CLEAN_INVOICES_STATS_STATE";

export const readInvoicesStats = (clientId = "") => {
    return async (dispatch) => {
        try {
            dispatch(fetchInvoicesStatsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post("/api/stats/invoices", { clientId }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchInvoicesStatsSuccess, fetchInvoicesStatsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchInvoicesStatsError));
        }
    };
};

const fetchInvoicesStatsRequest = () => {
    return {
        type: FETCH_INVOICES_STATS_REQUEST
    };
};

const fetchInvoicesStatsSuccess = (payload) => {
    return {
        type: FETCH_INVOICES_STATS_SUCCESS,
        payload
    };
};

const fetchInvoicesStatsError = (errorMessage) => {
    return {
        type: FETCH_INVOICES_STATS_ERROR,
        errorMessage
    };
};

export const cleanInvoicesStatsState = () => {
    return {
        type: CLEAN_INVOICES_STATS_STATE
    }
}